module.exports = __webpack_public_path__ + "img/inu_gallery13.a1b31410.jpg";